import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const VisitorUploadsTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.visitor-uploads-title" />;
